<template>
  <div class="header">
    <div class="hearder-logo">
      <img class="logo" height="58" src="@/assets/logo.png">
      <h1>广州劳动仲裁院</h1>
    </div>
    <div class="hearder-userinfo">
      <div class="entry">
        <span class="username">
          帐号：{{userName}}
        </span>
        <span class="logout" @click="logOut">退出</span>
      </div>
    </div>
  </div>
</template>

<script>
import { loginOut } from '@/api/login.js'
import { removeStore, removeStoreSession, getStoreSession, getStore } from '@/utils/utils.js'
export default {
  data() {
    return {
      userName: ''
    }
  },
  methods: {
    logOut() {
      loginOut().then((res) => {
        let workerInfo = JSON.parse(getStore("loginInfo_worker"));
        console.log('退出成功')
        removeStore('flk');
        removeStore('refreshToken');
        removeStore("loginInfo_worker");
        removeStore('loginInfouser');
        removeStoreSession('haslogin');
        if (workerInfo) {
          this.$router.push({ path: '/loginWorker' });
        } else {
          this.$router.push({ path: '/login' });
        }
      }, (err) => {
      })
    },
  },
  mounted() {
    if (getStoreSession('haslogin') == 'yes') {
      this.flag = true
      let loginInfo = JSON.parse(getStore("loginInfo_worker"));
      let loginInfouser = JSON.parse(getStore('loginInfouser'));
      this.userName = loginInfo.userInfo.userName||loginInfouser.userInfo.userName
    }
  }
}
</script>
<style lang="scss">
.el-dropdown-menu {
  .el-dropdown-menu__item {
    text-align: center;
  }
}
.header {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  color: #333;
  background-color: #fff;
  box-shadow: 0px 2px 6px 0px rgba(67, 146, 127, 0.11);
  .hearder-logo {
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 80px;
    .logo {
      margin-left: 30px;
    }
    h1 {
      margin-left: 16px;
      font-size: 20px;
      color: #222222;
    }
  }
  .hearder-userinfo {
    display: flex;
    align-items: center;
    padding: 0 20px;
    color: #333333;
    .entry {
      margin-right: 0;
    }
    .username {
      font-size: 16px;
      color: #999;
      img {
        margin-top: -3px;
        margin-right: 10px;
        vertical-align: middle;
      }
    }
    .logout {
      margin-left: 32px;
      cursor: pointer;
      color: #999;
    }
    .el-button--text {
      font-size: 16px;
      color: #333333;
    }
    .loginout {
      margin-left: 32px;
    }
    .split {
      width: 1px;
      height: 16px;
      margin: 0 20px;
      background-color: #999999;
      display: inline-block;
    }
  }
}
.login {
      a {
        font-size: 16px;
        color: #333;
        font-weight: bold;
        margin: 0 20px;
        display: inline-block;
        text-align: center;
      }
    }
</style>
